import React from 'react';
import {
  FeatureStrip,
  FeatureStripItem,
  FeatureStripIcon,
} from './FeaturesStrip.styles';
import { FaUsers, FaChartBar, FaBell, FaCertificate } from 'react-icons/fa';
const FeaturesStrip = () => {
  return (
    <FeatureStrip>
      <FeatureStripItem>
        <FeatureStripIcon>
          <FaUsers />
        </FeatureStripIcon>

        <div>
          <strong>Employee Management</strong>
          <span>Keep your training roster together.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaChartBar />
        </FeatureStripIcon>

        <div>
          <strong>Progress Tracking</strong>
          <span>See who has completed what.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaBell />
        </FeatureStripIcon>

        <div>
          <strong>Completion Updates</strong>
          <span>Stay informed as training is completed.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaCertificate />
        </FeatureStripIcon>

        <div>
          <strong>Training Certificates</strong>
          <span>Access records from completed courses.</span>
        </div>
      </FeatureStripItem>
    </FeatureStrip>
  );
};

export default FeaturesStrip;
